import { FC } from "react";
import NotResultsComponentProps from "./NotResultsComponentProps";
import "./NoResultsComponentStyle.scss";

const NotResultsComponent: FC<NotResultsComponentProps> = ({ 
    message, 
    icon, 
    subtitle, 
    actionText, 
    onAction 
}) => {
    return (
        <div className="no_results_component">
            <div className="no_results_content">
                <div className="no_results_icon">
                    {icon ? (
                        <span className="material-symbols-outlined">
                            {icon}
                        </span>
                    ) : (
                        <span className="material-symbols-outlined">
                            search_off
                        </span>
                    )}
                </div>
                
                <div className="no_results_text">
                    <h3 className="no_results_title">
                        {message ?? "Sin resultados"}
                    </h3>
                    
                    {subtitle && (
                        <p className="no_results_subtitle">
                            {subtitle}
                        </p>
                    )}
                </div>

                {actionText && onAction && (
                    <div className="no_results_action">
                        <button 
                            className="btn btn-primary btn-sm"
                            onClick={onAction}
                        >
                            {actionText}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NotResultsComponent;